import React, { useState } from 'react';
import { AlertCircle, ChevronDown, ChevronUp } from 'lucide-react';

export default function ErrorBoundaryFallback({ error, resetErrorBoundary }) {
  const [showDetails, setShowDetails] = useState(false);

  const handleRefresh = () => {
    window.location.reload();
  };

  const isDev = Boolean(import.meta.env?.DEV);
  const hasErrorMessage = isDev && error?.message;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="d-flex align-items-center justify-content-center min-vh-100 p-3"
    >
      <div
        className="theme-card rounded-3 shadow-lg overflow-hidden border"
        style={{ maxWidth: '440px', width: '100%' }}
      >
        <div className="pt-4 px-4 pb-2 text-center">
          <div
            className="d-flex align-items-center justify-content-center mx-auto mb-3 rounded-circle bg-danger text-white"
            style={{ width: '64px', height: '64px' }}
          >
            <AlertCircle size={36} />
          </div>
          <h1 className="h5 fw-bold mb-2">Something went wrong</h1>
          <p
            className="text-muted small mx-auto mb-4"
            style={{ maxWidth: '360px', lineHeight: 1.5 }}
          >
            An unexpected error occurred. Try again or refresh the page—if it keeps happening,
            please contact support.
          </p>
        </div>

        {hasErrorMessage && (
          <div className="px-4 pb-2">
            <button
              type="button"
              className="xs-btn xs-btn-link xs-btn-sm text-muted text-decoration-none d-flex align-items-center gap-1 p-0 mb-2"
              onClick={() => setShowDetails((v) => !v)}
            >
              {showDetails ? 'Hide' : 'Show'} technical details
              {showDetails ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>

            <div className={`collapse ${showDetails ? 'show' : ''}`}>
              <pre
                className="p-3 rounded text-start text-muted mb-3 border font-monospace theme-card"
                style={{ fontSize: '0.75rem', maxHeight: '140px', overflowY: 'auto' }}
              >
                {error.message}
              </pre>
            </div>
          </div>
        )}

        <div className="d-flex gap-2 flex-wrap justify-content-center p-4 pt-3 border-top">
          <button
            type="button"
            className="xs-btn xs-btn-primary fw-bold"
            style={{ minWidth: '120px' }}
            onClick={resetErrorBoundary}
          >
            Try again
          </button>
          <button
            type="button"
            className="xs-btn xs-btn-primary fw-bold"
            style={{ minWidth: '120px' }}
            onClick={handleRefresh}
          >
            Refresh page
          </button>
        </div>
      </div>
    </div>
  );
}
